module.exports = __webpack_public_path__ + "img/img-12.c79d5b7a.png";